import create from 'zustand'


export const useStore = create( set => ({
    image_show: false,
    startImageShow: () => set(state => ({...state, image_show: true})),
    stopImageShow: () => set(state => ({...state, image_show: false})),
}))